import React from "react";
import { useTranslation } from "react-i18next";
import { dateFormatter } from "../../utils/helpers/dateFormatter";
import WhitePdfButton from "../WhitePdfButton/WhitePdfButton";
import letterIcon from "../../assets/images/letter-icon.png";
import UserCmDoc from "../../entities/UserCMDoc";
import "./LettersReports.scss";


const LetterOption = (props: { cmLetter: UserCmDoc , fundName:[any] }) => {
  const { t, i18n } = useTranslation("common");


  const mapFundName = () =>{
   return props.fundName.map(item=> {return props.cmLetter?.FundCode === item.fundID ? i18n.language === "he"? item.fundNameHeb: item.fundNameArabic: null })
  }

  return (

      <li className="letters-reports-details" key={props.cmLetter?.Uri}>
        <div className="letters-reports-details-right">
          <div className="d-flex align-items-center">
            <img src={letterIcon} alt="" role="presentation" aria-hidden="true"/>
            <span className="letters-right-status-label">
              {t("LettersReports.letter")}
            </span>
            <span className="line">| </span>
            <span className="letters-left-date">
              {dateFormatter(props.cmLetter.DocDate)}
            </span>
          </div>
          <div className="d-flex align-items-center">
            <h2 className="letters-right-message-label initial-mg-right">
              {props?.cmLetter?.DocDisplayName}
            </h2>
          </div>
          <span className="letters-right-attention-label">
          {mapFundName()}
          </span>
        </div>
        <div className="letters-reports-details-left">
        {props.cmLetter.PId ? <WhitePdfButton PId={Number(props.cmLetter.PId)} /> : null}
        </div>
    </li>
  );
};

export default LetterOption;
